module.exports = __webpack_public_path__ + "img/1720579889629-image.jpg.faf3e54c.webp";